import { createMuiTheme } from '@material-ui/core';
import { breakpoints } from './breakpoints';
import { createOverrides } from './overrides';
import { palette } from './palette';
import { props } from './props';
import { typography } from './typography';
export type { Theme } from '@material-ui/core';
export { useTheme } from '@material-ui/core';

export const theme = createMuiTheme({ breakpoints, palette, props, typography });

theme.overrides = createOverrides(theme);
